/* eslint-disable */
type CrTimestamp = number;
type CrJson = any;
type CrBigInt = number;
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPaymentNotificationList
// ====================================================

export interface GetPaymentNotificationList_payment_notification_list_item_list_payment_notification_content_list {
  /**
   * 언어 코드
   */
  language: string;
  /**
   * 내용
   */
  content: string;
}

export interface GetPaymentNotificationList_payment_notification_list_item_list {
  /**
   * 기본 키
   */
  id: string;
  /**
   * 결제 수단
   */
  payment_method: PaymentMethod;
  /**
   * 알림 타입
   */
  notification_type: PaymentNotificationType;
  /**
   * 결제 금융사
   */
  financial_company_code: FinancialCompanyCode | null;
  /**
   * 최소 금액
   */
  min_amount: number | null;
  /**
   * 할인 금액
   */
  discount_amount: number | null;
  /**
   * 결제 알림 문구 리스트
   */
  payment_notification_content_list: GetPaymentNotificationList_payment_notification_list_item_list_payment_notification_content_list[];
}

export interface GetPaymentNotificationList_payment_notification_list {
  /**
   * 결제 알림 정보 목록
   */
  item_list: GetPaymentNotificationList_payment_notification_list_item_list[];
}

export interface GetPaymentNotificationList {
  /**
   * 주어진 조건 모두에 일치하는 결제 알림 정보를 반환한다.
   * 조건에 맞는 결제 알림 정보가 없으면 빈 목록을 반환한다.
   */
  payment_notification_list: GetPaymentNotificationList_payment_notification_list;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum FinancialCompanyCode {
  B_BUSAN = "B_BUSAN",
  B_CITY = "B_CITY",
  B_DAEGU = "B_DAEGU",
  B_GWANGJU = "B_GWANGJU",
  B_GYEONGNAM = "B_GYEONGNAM",
  B_HANA = "B_HANA",
  B_HSBC = "B_HSBC",
  B_IBK = "B_IBK",
  B_JEJU = "B_JEJU",
  B_JEONBUK = "B_JEONBUK",
  B_KAKAOBANK = "B_KAKAOBANK",
  B_KB = "B_KB",
  B_KBANK = "B_KBANK",
  B_KDB = "B_KDB",
  B_KEB = "B_KEB",
  B_NH = "B_NH",
  B_POST = "B_POST",
  B_SC = "B_SC",
  B_SHINHAN = "B_SHINHAN",
  B_SHINHYUP = "B_SHINHYUP",
  B_SUHYUP = "B_SUHYUP",
  B_WOORI = "B_WOORI",
  C_BC = "C_BC",
  C_CITY = "C_CITY",
  C_GWANGJU = "C_GWANGJU",
  C_HANA = "C_HANA",
  C_HYUNDAI = "C_HYUNDAI",
  C_JEJU = "C_JEJU",
  C_JEONBUK = "C_JEONBUK",
  C_KAKAOBANK = "C_KAKAOBANK",
  C_KB = "C_KB",
  C_KBANK = "C_KBANK",
  C_KDB = "C_KDB",
  C_LOTTE = "C_LOTTE",
  C_NH = "C_NH",
  C_POST = "C_POST",
  C_SAMSUNG = "C_SAMSUNG",
  C_SHINHAN = "C_SHINHAN",
  C_SHINHYUP = "C_SHINHYUP",
  C_SUHYUP = "C_SUHYUP",
  C_WOORI = "C_WOORI",
  UNKNOWN = "UNKNOWN",
}

export enum PaymentMethod {
  BANK = "BANK",
  BENEPIA_POINT = "BENEPIA_POINT",
  CARD = "CARD",
  CONVENIENCE_STORE = "CONVENIENCE_STORE",
  CONVENIENCE_STORE_JP = "CONVENIENCE_STORE_JP",
  GLOBAL_CARD = "GLOBAL_CARD",
  KAKAOPAY = "KAKAOPAY",
  PHONE = "PHONE",
  POINT = "POINT",
  SIMPLE_BANK = "SIMPLE_BANK",
  SIMPLE_CARD = "SIMPLE_CARD",
  TOSSPAY = "TOSSPAY",
  UNDEFINED_PAYMENT_METHOD = "UNDEFINED_PAYMENT_METHOD",
  VBANK = "VBANK",
}

export enum PaymentNotificationType {
  EVENT = "EVENT",
  GUIDE = "GUIDE",
  NOTICE = "NOTICE",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
